import { Toast, ToastrService, ToastPackage } from 'ngx-toastr';

import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef } from '@angular/core';

import { SnAlarm } from '@lib/api/entities';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[fs-amber-alert-toast]',
  templateUrl: './amber-alert-toast.component.html',
  styleUrls: ['./amber-alert-toast.component.scss'],
  preserveWhitespaces: false,
  animations: [
    trigger('flyInOut', [
      state(
        'inactive',
        style({
          opacity: 0,
        }),
      ),
      transition(
        'inactive => active',
        animate(
          '400ms ease-out',
          keyframes([
            style({
              transform: 'translate3d(100%, 0, 0) skewX(-30deg)',
              opacity: 0,
            }),
            style({
              transform: 'skewX(20deg)',
              opacity: 1,
            }),
            style({
              transform: 'skewX(-5deg)',
              opacity: 1,
            }),
            style({
              transform: 'none',
              opacity: 1,
            }),
          ]),
        ),
      ),
      transition(
        'active => removed',
        animate(
          '400ms ease-out',
          keyframes([
            style({
              opacity: 1,
            }),
            style({
              transform: 'translate3d(100%, 0, 0) skewX(30deg)',
              opacity: 0,
            }),
          ]),
        ),
      ),
    ]),
  ],
})
export class AmberAlertToastComponent extends Toast {
  public alarm: SnAlarm;

  constructor(
    protected toastrService: ToastrService,
    public toastPackage: ToastPackage,
    public element: ElementRef,
  ) {
    super(toastrService, toastPackage);
  }
}
